import React from 'react'

const Plus = (props) => <span className="plus"><span className={'plus-v ' + ( props.selected ? 'selected' : '' )}></span><span className='plus-h'></span></span>

export default Plus


// WEBPACK FOOTER //
// ./src/components/_Plus.js